import { StyleSheet } from 'aphrodite'

import main from './main'

export default {
  main: StyleSheet.create(main)
}



// WEBPACK FOOTER //
// ./src/components/partials/DashboardContainer/style/index.js